import PaymentStatus from "../../components/infoPages/PaymentStratus/paymentStatus";

const PaymentStatusPage = ({ authUser }) => {
  return (
    <>
        <PaymentStatus authUser={authUser} />
    </>
  )
}

export default PaymentStatusPage;